@if (title) {
  <h1 mat-dialog-title>{{title}}</h1>
}
<div mat-dialog-content>
  @if (description) {
    <p [innerHTML]="description"></p>
  }
  @if (selectionOptions?.length === 1) {
    <b>{{ selectionOptions[0].labelShouldBeTranslated ? (selectionOptions[0].label | translate: selectionOptions[0].labelParams ) : selectionOptions[0].label }}</b>
  }
  @if (selectionOptions?.length >= 2) {
    <mat-form-field appearance="outline">
      @if (data.selectionOptionLabel) {
        <mat-label>
          {{ (data.selectionOptionLabelShouldBeTranslated ? (data.selectionOptionLabel | translate) : data.selectionOptionLabel) }}
        </mat-label>
      }
      <mat-select [formControl]="optionControl" [placeholder]="('choice_dialog.select.placeholder' | translate)">
        @for (option of data.selectionOptions; track option.value) {
          @if (!( checkboxGroup.get(option.disableWhen)?.value )) {
            <mat-option [value]="option.value">
              {{ option.labelShouldBeTranslated ? (option.label | translate: option.labelParams) : option.label }}
            </mat-option>
          }
        }
      </mat-select>
    </mat-form-field>
  }
  <form class="flex-col flex-1"Fill [formGroup]="checkboxGroup">
    @for (checkboxOption of checkboxOptions; track checkboxOption.value) {
      <div class="flex-row">
        @if (shouldShowCheckboxOption(checkboxOption, optionControl.value)) {
          <mat-checkbox
            color="primary"
            [formControlName]="checkboxOption.value"
          >
            <p>{{ checkboxOption.labelShouldBeTranslated ? (checkboxOption.label | translate: checkboxOption.labelParams) : checkboxOption.label }}</p>
          </mat-checkbox>
        }
      </div>
    }
  </form>
</div>
<div mat-dialog-actions>
  @if (!hideCancel) {
    <button mat-button (click)="onNoClick()">{{ 'generic.cancel' | translate | uppercase }}</button>
  }
  @if (actions.primaryAction; as action) {
    <button mat-button color="primary" (click)="confirm( action.value )" [disabled]="action.disableWhen && ( action.disableWhen === optionControl.value || checkboxGroup.get(action.disableWhen)?.value )" cdkFocusInitial>{{ action.labelShouldBeTranslated ? (action.label | translate: action.labelParams) : action.label }}</button>
  }
  @if (actions.secondaryAction; as action) {
    <button mat-button color="accent" (click)="confirm( action.value )" [disabled]="action.disableWhen && ( action.disableWhen === optionControl.value || checkboxGroup.get(action.disableWhen)?.value )">{{ action.labelShouldBeTranslated ? (action.label | translate: action.labelParams) : action.label }}</button>
  }
</div>
